module.exports = __webpack_public_path__ + "assets/img/bga.e24bcbd9.png";